import { TypeComponentNoti } from "@/enums/enums";
import { i18n } from "@/i18n";
import store from "@/store/index";
import API from "@/service/Index";
import {
  GetKeepLogin,
  SetCookiesAccessToken,
  SetCookiesRefreshToken
} from "@/helper/userHelper";

const maxFileSize = 10;
const maxFileCountDefault = 10;
const fileTypeList = [
  ".pdf",
  ".png",
  ".jpg",
  ".gif",
  ".txt",
  ".mp4",
  ".mov",
  ".csv",
  ".xlsx",
  ".docx",
  ".zip",
  ".rar",
  ".7z",
  ".jpeg",
  ".pptx",
  ".key",
  ".rdx",
  ".heic",
  ".heif",
];

export const MAX_FILE_PRODUCT_IMAGE_SIZE = 3 * 1024 * 1024;

export function ReadFileAsync(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      resolve(e.target.result);
    };
    reader.readAsDataURL(file);
  });
}

async function ValidateTrueImage(file: File, nameFileType: string) {
  if (nameFileType == ".png" || nameFileType == ".jpg" || nameFileType == ".jpeg") {
    const rawString = await ReadFileAsync(file);
    const image: any = new Image();
    image.src = rawString;
    return await new Promise((resolve) => {
      image.onload = function() {
        if (image.height === 0 || image.width === 0) {
          resolve(false);
        }
        resolve(true);
      };
      image.onerror = () => {
        resolve(false);
      };
    });
  } else {
    return true;
  }
}

export async function ValidateUploadFile(
  file: File,
  fileType: string,
  fileList: any,
  fileCount: any,
  maxFileCount: number = maxFileCountDefault,
  allowedFileTypeList: Array<string> | null = null
) {
  const fileName = file.name;
  const fileTypeValidateList = allowedFileTypeList ? allowedFileTypeList : fileTypeList;

  if (fileName.length > 0) {
    let validateFileType = false;
    let nameFileType = "";
    let validateFileImage: any = true;
    for (let j = 0; j < fileTypeValidateList.length; j++) {
      const fileType = fileTypeValidateList[j];
      if (fileName.substr(fileName.length - fileType.length, fileType.length).toLowerCase() == fileType.toLowerCase()) {
        nameFileType = fileType.toLowerCase();
        validateFileType = true;
        break;
      }
    }

    if (!validateFileType) {
      store.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("Validate_Upload_File_Type", {
            filename: fileName,
            fileTypeList: fileTypeValidateList.join(", "),
          }),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
      return false;
    } else {
      validateFileImage = await ValidateTrueImage(file, nameFileType);
    }

    if (!validateFileImage) {
      store.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("Validate_Upload_File_True_Image"),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
      return false;
    }
  }

  if (file.size / 1024 / 1024 > maxFileSize) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        alertMessage: i18n.t("Validate_Upload_File_larger", { maxFileSize: maxFileSize }),
        typeMessage: TypeComponentNoti.error,
      },
      { root: true }
    );
    return false;
  }

  if (fileCount > maxFileCount) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Validate_Upload_File_Count", { maxFileCount: maxFileCount }),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  if (fileList.some((fileItem: any) => fileItem.fileName === file.name)) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Validate_Upload_File_duplicate"),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  if (file.size === 0) {
    store.dispatch("Alert/SetAlertMessage", {
      alertMessage: i18n.t("Upload_Fail_No_Content"),
      typeMessage: TypeComponentNoti.error,
    });
    return false;
  }

  return true;
}

export function ValidFilesSizeUpload(fileSize: number, totalFilesSize: number) {
  if (totalFilesSize - fileSize < 0) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        alertMessage: i18n.t("Validate_Upload_Total_Files_larger", { maxFileSize: maxFileSize }),
        typeMessage: TypeComponentNoti.error,
      },
      { root: true }
    );
    return false;
  }
  return true;
}

export function SetAlertAddFileStorage(
  responseList: Array<any>,
  isSuccess: boolean,
  idNoificition: number,
  input: any
) {
  if (isSuccess) {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        id: idNoificition,
        typeUpload: "End",
        alertMessage: i18n.t(
          "Upload_Success",
          input.fileList.length > 1 ? { msg: " " + responseList.length + " " } : { msg: input.fileList[0].fileName }
        ),
        typeMessage: TypeComponentNoti.Success,
      },
      { root: true }
    );
  } else {
    store.dispatch(
      "Alert/SetAlertMessage",
      {
        id: idNoificition,
        typeUpload: "End",

        alertMessage: i18n.t("Upload_Fail", { msg: " " + responseList.length + " " }),
        typeMessage: TypeComponentNoti.Error,
      },
      { root: true }
    );
  }
}

export const CalculateDimensions = (naturalWidth: number, naturalHeight: number, max: number) => {
  if (naturalWidth <= 0 || naturalHeight <= 0) {
    return { width: 0, height: 0 };
  }

  if (naturalWidth <= max && naturalHeight <= max) {
    return { width: naturalWidth, height: naturalHeight };
  }

  if (naturalHeight > naturalWidth) {
    const percentChange = (max * 100) / naturalHeight;
    const width = (naturalWidth * percentChange) / 100;
    return { width: width, height: max };
  } else if (naturalHeight < naturalWidth) {
    const percentChange = (max * 100) / naturalWidth;
    const height = (naturalHeight * percentChange) / 100;
    return { width: max, height: height };
  } else {
    return { width: max, height: max };
  }
};

export const CompressImageToBase64 = (imageSrc: string, max = 300) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imageSrc;

    img.onload = () => {
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;

      const dimensions = CalculateDimensions(naturalWidth, naturalHeight, max);
      const { width, height } = dimensions;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;

      context?.drawImage(img, 0, 0, width, height);

      const base64Data = canvas.toDataURL("image/png");
      resolve(base64Data);
    };

    img.onerror = (err) => {
      resolve("");
    };
  });
};

export const ConvertFileUrlFromBlobStorageToFileService = (url: string) => {
  if (!url) return "";
  const fileServiceUrl: string = process.env.VUE_APP_PeakFileService || "";
  const blobStorageUrl: string = process.env.VUE_APP_PeakBlobStorage || "";

  if (url.startsWith(fileServiceUrl)) {
    return url;
  }

  return `${fileServiceUrl}/file/${url.replace(blobStorageUrl, "")}`;
};

/**
 * Fetch with automatic token refresh on 401.
 * If the request returns 401, it will refresh the token and retry once.
 * @param {string} url - The URL to fetch
 * @param {object} options - Fetch options (will add credentials: 'include' automatically)
 * @returns {Promise<Response>} - The fetch response
 */
export const FetchWithTokenRefresh = async (url: string, options = {}) => {
  const fetchOptions = { ...options, credentials: "include" as const };
  
  const response = await fetch(url, fetchOptions);
  
  if (response.status === 401) {
    // Attempt to refresh the token
    try {
      const refreshResult = await API.AuthenService.DoGetNewAccessTokenByRefreshToken();
      if (refreshResult && refreshResult.status && refreshResult.status.IsSuccess()) {
        // Update cookies with new tokens
        const keepLogin = GetKeepLogin();
        SetCookiesAccessToken(refreshResult.data.access_token);
        SetCookiesRefreshToken(refreshResult.data.refresh_token, keepLogin);
        
        // Retry the original request
        return await fetch(url, fetchOptions);
      } else {
        // Token refresh failed - throw will be caught by catch block which shows toast
        throw new Error("Session expired - token refresh failed");
      }
    } catch (error) {
      // Error during refresh, show error toast
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Cannot_Access_Image_From_Link"),
        typeMessage: TypeComponentNoti.error,
      });
      throw new Error("Session expired - token refresh error");
    }
  }
  
  return response;
};
